import {Component} from "@angular/core";

@Component({
    selector: "fui-modal-window-main",
    styleUrls: ["./modal-window-main.component.scss"],
    templateUrl: "./modal-window-main.component.html"
})
export class FUIModalWindowMainComponent {
}
